module.exports = __webpack_public_path__ + "static/media/about-ex-bg.b5b8966b.jpg";